import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { BarHeader } from 'dibs-elements/exports/BarHeader';
import ChairIcon from 'dibs-vg/dist/react/chair-outlined';
import HeartIcon from 'dibs-vg/dist/react/heart-outlined';
import GlassIcon from 'dibs-vg/dist/react/magnifying-glass';

import styles from './Content.scss';

export const ContentHead = () => (
    <div id="howItWorks" className="rowFlex rowWrapper">
        <div className={styles.wrapper}>
            <div className={styles.headerWrapper}>
                <BarHeader
                    title={
                        <div className={styles.header}>
                            <FormattedMessage
                                id="abt.sourcing.content.header"
                                defaultMessage="How It Works"
                            />
                        </div>
                    }
                />
                <div className={`rowFlex ${styles.iconWrapper}`}>
                    <div className={styles.iconItem}>
                        <ChairIcon className={styles.svgIcon} />
                        <div className={styles.iconHeader}>
                            <FormattedMessage
                                id="abt.sourcing.content.aboutProjectHeader"
                                defaultMessage="Tell Us What You Need"
                            />
                        </div>
                        <div className={styles.iconContent}>
                            <FormattedMessage
                                id="abt.sourcing.content.aboutProjectSubheader"
                                defaultMessage="Share some information about your project and the items you need."
                            />
                        </div>
                    </div>
                    <div className={styles.iconItem}>
                        <GlassIcon className={styles.svgIcon} />
                        <div className={styles.iconHeader}>
                            <FormattedMessage
                                id="abt.sourcing.content.findItemsHeader"
                                defaultMessage="We'll Start Sourcing"
                            />
                        </div>
                        <div className={styles.iconContent}>
                            <FormattedMessage
                                id="abt.sourcing.content.findItemsSubheader"
                                defaultMessage="Our experts will leverage the 1stdibs seller network to find, unique, customizable, or even unpublished items."
                            />
                        </div>
                    </div>
                    <div className={styles.iconItem}>
                        <HeartIcon className={styles.svgIcon} />
                        <div className={styles.iconHeader}>
                            <FormattedMessage
                                id="abt.sourcing.content.letUsHelpHeader"
                                defaultMessage="Review Sourced Items"
                            />
                        </div>
                        <div className={styles.iconContent}>
                            <FormattedMessage
                                id="abt.sourcing.content.letUsHelpSubheader"
                                defaultMessage="In just 2 business days, you'll be able to review the sourced items in your Favorites folder."
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
);

ContentHead.displayName = 'ContentHead';

const Person = ({ name, photo, description }) => (
    <div className={styles.personWrapper}>
        <div className={styles.personPhoto} style={{ backgroundImage: `url(${photo})` }} />
        <div className={styles.personTextWrapper}>
            <div className={styles.personName}>{name}</div>
            <div className={styles.personDescription}>{description}</div>
        </div>
    </div>
);

Person.propTypes = {
    name: PropTypes.string.isRequired,
    photo: PropTypes.string.isRequired,
    description: PropTypes.node.isRequired,
};

export const ContentBody = () => (
    <div className="rowFlex">
        <div className="rowWrapper">
            <div className={styles.contentWrapper}>
                <BarHeader
                    title={
                        <div className={styles.header}>
                            <FormattedMessage
                                id="abt.sourcing.contentBody.header"
                                defaultMessage="Meet The Team"
                            />
                        </div>
                    }
                />
                <div className={styles.contentText}>
                    <FormattedMessage
                        id="abt.sourcing.contentBody.content"
                        defaultMessage="Our dedicated sourcing experts work directly with sellers, so they’re able to get you the best prices and can even  access items not yet available onsite."
                    />
                </div>
                <div className={styles.teamWrapper}>
                    <Person
                        name="Randi B."
                        photo="https://a.1stdibscdn.com/assets/trade/sourcing/team-randyll.jpg"
                        description={
                            <FormattedMessage
                                id="abt.sourcing.contentBody.descriptionRandi"
                                defaultMessage="Seasoned in the design industry, she specializes in high-end corporate interior design with a Master's degree in Design Strategy and Innovation."
                            />
                        }
                    />
                    <Person
                        name="Lauren S."
                        photo="https://a.1stdibscdn.com/assets/trade/sourcing/team-lauren.jpg"
                        description={
                            <FormattedMessage
                                id="abt.sourcing.contentBody.descriptionLauren"
                                defaultMessage="Her in-depth knowledge of art and design history was invaluable during her time at Artnet, where she managed the auction database."
                            />
                        }
                    />
                    <Person
                        name="Stephanie C."
                        photo="https://a.1stdibscdn.com/assets/trade/sourcing/team-stephanie.jpg"
                        description={
                            <FormattedMessage
                                id="sourcing.contentBody.descriptionStephanie"
                                defaultMessage="She has experience designing for high-end residences and has a Master’s degree in Decorative Arts and Design History, focusing on 20th Century American Furniture and Scandinavian Design."
                            />
                        }
                    />
                    <Person
                        name="Molly S."
                        photo="https://a.1stdibscdn.com/assets/trade/sourcing/team-molly.jpg"
                        description={
                            <FormattedMessage
                                id="abt.sourcing.contentBody.descriptionMolly"
                                defaultMessage="She has an academic background in art history, along with professional experience working for contemporary artists and design galleries."
                            />
                        }
                    />
                    <Person
                        name="Jonathan W."
                        photo="https://a.1stdibscdn.com/assets/trade/sourcing/team-jonathan.jpg"
                        description={
                            <FormattedMessage
                                id="abt.sourcing.contentBody.descriptionJonathan"
                                defaultMessage="He has extensive experience as a picker, selling vintage design to top galleries in New York and Los Angeles."
                            />
                        }
                    />
                </div>
            </div>
        </div>
    </div>
);

ContentBody.displayName = 'ContentBody';
